export enum IdentityProviderTypeEnum {
  SAML = 'SAML',
  PASSWORD = 'PASSWORD',
}
